// import React, { useState, Fragment, Component } from 'react'
// import React, { Fragment, useState, Component, useRef, useEffect } from "react"

import React, { Fragment, useState, Component, useRef, useEffect } from "react"

import moment from "moment"
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle, Tooltip,
    Button,
    Table,
    Spinner
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'

import { Link } from "react-router-dom"
import { withRouter } from "react-router";
import { AvForm } from "availity-reactstrap-validation"
import apiResponse from '../../../../services/apiResponse'
import DetailBloc from './Blocs/DetailBloc'

const formatDateNoTime = (value) => {
    if (value != '-' && value != '' && value != null) {
        let date = new Date(value);
        const day = date.toLocaleString('id-ID', { day: '2-digit' });
        const month = date.toLocaleString('id-ID', { month: '2-digit' });
        const year = date.toLocaleString('id-ID', { year: 'numeric' });

        return day + '-' + month + '-' + year;
    } else {
        return '-';
    }
}
const SortByName = (a, b) => {
    var anewdate = (a.tanggalSk).split("-").reverse().join("-");
    var bnewdate = (b.tanggalSk).split("-").reverse().join("-");
    var aName = bnewdate;
    var bName = anewdate;
    return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
}
const EmployeeDetailItem = ({ label, value, loading, shimmerWidth }) => (
    <Row className="mb-1">
      <label className="col-md-3">{label}</label>
      <Col md="9">
        {loading ? (
          <>{value}</>
        ) : (
          <Shimmer>
            <div style={{ width: typeof shimmerWidth === 'number' ? `${shimmerWidth}px` : shimmerWidth, height: 15 }}></div>
          </Shimmer>
        )}
      </Col>
    </Row>
  );

class IndexView extends Component {

    detailBloc = new DetailBloc()

    userdata = JSON.parse(localStorage.getItem('userdata'));

    constructor(props) {
        super(props)
        this.state = {

        }

    }

    componentDidMount() {
        this.detailBloc.fetchDetail({ uuid: this.props.uuid })
        this.detailBloc.BKNServiceIdentitas({ uuid: this.props.uuid })
        this.detailBloc.fetchListDiklat({ uuid: this.props.uuid })
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        // console.log(response)
                        this.setState({
                            detail: response
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
        this.detailBloc.BKNServiceIdentitasChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result?.data?.response
                        // console.log(response)
                        this.setState({
                            bknServiceIdentitas: response?.data,
                            pnsId: response?.data?.id,
                            instansiId: response?.data?.instansiKerjaId,
                        })
                        //console.log('xxx')
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
        this.detailBloc.listDiklatChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let res = result.data.response
                        // var wew = (Array.isArray(res.bkn.data)?res.bkn.data:[]).sort(SortByName);
                        // console.log(wew)


                        this.setState({
                            diklatListBkn: res.bkn || [],
                            diklatListSimpeg: res.simpeg || []
                        })
                        this.setState({ loadingTable: false })

                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
        this.detailBloc.sendToBKNChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        let code = response.code

                        if (code == 0) {
                            this.setState({
                                loading: false,
                                failed: true,
                                loadingTable: false
                            });
                        } else {
                            this.setState({
                                loading: false,
                                success: true,
                                loadingTable: false
                            });
                            this.handleIntegrasiDiklat()
                        }

                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
        this.detailBloc.sendToSIMPEGChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        this.setState({
                            loading: false,
                            success: true,
                            loadingTable: false
                        });
                        this.handleIntegrasiDiklat()

                    } else {
                        this.setState({
                            loading: false,
                            failed: true,
                            loadingTable: false
                        });
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
        this.detailBloc.downloadFileChannel.subscribe((result) => {

            switch (result.status) {
                case apiResponse.LOADING:
                    this.setState({
                        loading: true,
                    })
                    break
                case apiResponse.COMPLETED:
                    console.log('xxxx');
                    const link = result.data.response
                    window.open(link.file_url, "_blank")
                    //window.location.href = link.file_url
                    this.setState({
                        loading: false,
                        success: true
                    })
                    setTimeout(() => {
                        this.setState({
                            success: false,
                        })
                    }, 1000);
                    break
                case apiResponse.ERROR:
                    this.setState({
                        urlFileDetail: link,
                        loading: false,
                        failed: true
                    })
                    setTimeout(function () {
                        this.setState({
                            failed: false,
                        })
                    }, 1000)
                    break
                default:
                    break
            }
        })
    }

    handleIntegrasiDiklat = () => {
        this.setState({ loadingTable: true })
        this.detailBloc.fetchListDiklat({ uuid: this.props.uuid })
    }

    handleDownloadFile = (path) => {
        this.detailBloc.downloadFile({
            uuid: this.state.process_download_uuid,
            fileurl: path
        });
    }

    sendToBKN() {
        this.detailBloc.sendToBKN({
            uuid: this.userdata?.employee_uuid,
            pnsId: this.state.pnsId,
            instansiId: this.state.instansiId,
            process_uuid: this.state.process_uuid,
        })
    }

    sendToSIMPEG() {
        this.detailBloc.sendToSIMPEG({
            uuid: this.userdata?.employee_uuid,
            employee_uuid: this.props.uuid,
            send_nama_jabatan: this.state.send_nama_jabatan,
            send_nomor_sk: this.state.send_nomor_sk,
            send_tgl_sk: this.state.send_tgl_sk,
            send_tmt_jabatan: this.state.send_tmt_jabatan,
            process_uuid: this.state.process_uuid,
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    success: false,
                    redirect: true
                }
                // forState = {
                //     loading: true,
                //     confirm: false
                // }
                // if (this.state.runType == 5) {
                //     this.sendToBKN()
                // } else if (this.state.runType == 6) {
                //     this.sendToSIMPEG()
                // }
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }


    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            {/* <PegawaiSideBar active="riwayatsumpah"/> */}

                            <Card>
                                <CardBody>
                                    <CardTitle>Detail Data Integrasi</CardTitle>
                                    <CardSubtitle className="mb-1">
                                        Informasi Detail Data Integrasi
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                    // onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <EmployeeDetailItem label="NIP" loading={this.state.detail} value={this.state.detail?.employee_nip} shimmerWidth={68} />
                                        <EmployeeDetailItem label="Nama" loading={this.state.detail} value={this.state.detail?.employee_full_name} shimmerWidth="60%" />
                                        <EmployeeDetailItem label="Jabatan" loading={this.state.detail} value={this.state.detail?.employee_current_position_name} shimmerWidth="40%" />
                                        <EmployeeDetailItem label="Unit Kerja" loading={this.state.detail} value={this.state.detail?.employee_current_work_unit_name} shimmerWidth="40%" />
                                        <EmployeeDetailItem label="Terakhir Sinkronisasi" loading={this.state.detail} value={this.state.detail?.integrasi_update_date || this.state.detail?.integrasi_status_name} shimmerWidth="40%" />
                                        <hr />
                                        <br />
                                        <CardTitle>Data Jabatan &nbsp; &nbsp; &nbsp; <Button onClick={() => {
                                            this.handleIntegrasiDiklat()
                                        }} color="primary">Sinkronisasi Data Jabatan dari BKN</Button>
                                            {/* <Button color="danger">Rollback ke Versi sebelumnya</Button> */}
                                        </CardTitle>
                                        <br />
                                        <Row className="mb-1">
                                            <Col md="6">
                                                <div className="table-responsive">
                                                    <Table className="table table-striped table-bordered">
                                                        <thead className="table-primary">
                                                            <tr style={{ border: '1px solid rgb(200, 204, 225)' }}>
                                                                <th className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }} colSpan={4} width="95%">SIMPEG</th>
                                                                <th className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }} rowSpan={2} width="5%">Aksi</th>
                                                            </tr>
                                                            <tr style={{ border: '1px solid rgb(200, 204, 225)', backgroundColor: 'rgb(255, 250, 233)' }}>
                                                                <td className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }}>Nama Diklat</td>
                                                                <td className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }}>Tempat</td>
                                                                <td className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }}>Penyelenggara</td>
                                                                <td className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }}>Tahun Diselenggarakan</td>
                                                                {/* <td className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }}>Status</td> */}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                this.state.loadingTable == false ?
                                                                    this.state.diklatListSimpeg.length > 0 ?

                                                                        this.state.diklatListSimpeg.map((data, index) => {
                                                                            // const datadiklatListBkn = this.state.diklatListBkn;
                                                                            // const found = datadiklatListBkn?.some(el => el.nomorSk.trim().toLowerCase() === data.position_history_decree_number.trim().toLowerCase());
                                                                            // const sync = data.position_history_is_bkn == 1 || found;
                                                                            const sync = false;
                                                                            return (
                                                                                <tr style={{ border: '1px solid rgb(200, 204, 225)' }}>
                                                                                    <td className={sync? 'text-left text-success' : 'text-left'}>{data.training_type_name}</td>
                                                                                    <td className={sync? 'text-left text-success' : 'text-left'}>{data.training_place}</td>
                                                                                    <td className={sync? 'text-center text-success' : 'text-center'}>{data.training_organizer}</td>
                                                                                    <td className={sync? 'text-center text-success' : 'text-center'}>{data.training_year}</td>
                                                                                    {/* <td> <label className={`badge rounded-pill ${data.training_status ? "bg-soft-warning":"bg-soft-success"} font-size-12`} >{data.training_status_status_name}</label></td> */}
                                                                                    <td className={sync? 'text-center text-success' : 'text-center'}>
                                                                                        {
                                                                                            // data.position_history_is_bkn == null ?
                                                                                                <span>
                                                                                                    <button
                                                                                                        className="btn btn-primary btn-sm"
                                                                                                        id={"proses_" + data.training_uuid}
                                                                                                        onClick={() => {
                                                                                                            this.setState({
                                                                                                                // process_uuid: data.position_history_uuid,
                                                                                                                confirm: true,
                                                                                                                // runType: 5,
                                                                                                                confirmInfo: "Apakah anda yakin akan Mengirimkan data ini ke BKN?"
                                                                                                            })
                                                                                                        }}
                                                                                                        style={{
                                                                                                            marginRight: '2px',
                                                                                                            padding: '2px 5px'
                                                                                                        }}>
                                                                                                        <i className="uil-check-square"></i>
                                                                                                    </button>
                                                                                                    <Tooltip
                                                                                                        style={{
                                                                                                            marginBottom: 2
                                                                                                        }}
                                                                                                        placement="top" isOpen={this.state["detail_simpeg_" + data.training_uuid]} target={"proses_" + data.training_uuid}
                                                                                                        toggle={() => {
                                                                                                            this.setState({
                                                                                                                ["detail_simpeg_" + data.training_uuid]: !this.state["detail_simpeg_" + data.training_uuid]
                                                                                                            })
                                                                                                        }}
                                                                                                    >Kirim Ke BKN</Tooltip>
                                                                                                </span>
                                                                                                // :
                                                                                                // ''
                                                                                            }

                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        })

                                                                        :
                                                                        <tr style={{ border: '1px solid #c8cce1' }}>
                                                                            <td colSpan="5" className="text-center">Tidak Ada Data</td>
                                                                        </tr>
                                                                    :
                                                                    <tr style={{ border: '1px solid #c8cce1' }}>
                                                                        <td colSpan="5" className="text-center"><Spinner className="m-2" color="primary" /></td>
                                                                    </tr>

                                                            }
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </Col>
                                            <Col md="6">
                                                <div className="table-responsive">
                                                    <Table className="table table-striped table-bordered">
                                                        <thead className="table-primary">
                                                            <tr style={{ border: '1px solid rgb(200, 204, 225)' }}>
                                                                <th className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }} colSpan={4} width="95%">BKN</th>
                                                                <th className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }} rowSpan={2} width="5%">Aksi</th>
                                                            </tr>
                                                            <tr style={{ border: '1px solid rgb(200, 204, 225)', backgroundColor: 'rgb(255, 250, 233)' }}>
                                                                <td className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }}>Nama Diklat</td>
                                                                <td className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }}>Tempat</td>
                                                                <td className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }}>Penyelenggara</td>
                                                                <td className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }}>Tahun Diselenggarakan</td>
                                                                {/* <td className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }}>Status</td> */}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                this.state.loadingTable == false ?
                                                                    this.state.diklatListBkn.length > 0 ?

                                                                        this.state.diklatListBkn.map((data, index) => {
                                                                            // const datadiklatListSimpeg = this.state.diklatListSimpeg;
                                                                            // const found = datadiklatListSimpeg.some(el => el.position_history_decree_number.trim().toLowerCase() === data.nomorSk.trim().toLowerCase());
                                                                       
                                                                            const sync = false;
                                                                            return (
                                                                                <tr style={{ border: '1px solid rgb(200, 204, 225)' }}>
                                                                                    <td className={sync? 'text-left text-success' : 'text-left'}>{data.latihanStrukturalNama}</td>
                                                                                    <td className={sync? 'text-left text-success' : 'text-left'}>{data.training_place??"-"}</td>
                                                                                    <td className={sync? 'text-center text-success' : 'text-center'}>{data.institusiPenyelenggara}</td>
                                                                                    <td className={sync? 'text-center text-success' : 'text-center'}>{data.tahun}</td>
                                                                                    {/* <td> <label className={`badge rounded-pill ${data.training_status ? "bg-soft-warning":"bg-soft-success"} font-size-12`} >{data.training_status_status_name}</label></td> */}
                                                                                    <td className={sync? 'text-center text-success' : 'text-center'}>
                                                                                        {
                                                                                            // data.position_history_is_bkn == null ?
                                                                                                <span>
                                                                                                    <button
                                                                                                        className="btn btn-primary btn-sm"
                                                                                                        id={"proses_" + data.id}
                                                                                                        onClick={() => {
                                                                                                            this.setState({
                                                                                                                // process_uuid: data.position_history_uuid,
                                                                                                                confirm: true,
                                                                                                                // runType: 5,
                                                                                                                confirmInfo: "Apakah anda yakin akan Mengirimkan data ini ke SIMPEG?"
                                                                                                            })
                                                                                                        }}
                                                                                                        style={{
                                                                                                            marginRight: '2px',
                                                                                                            padding: '2px 5px'
                                                                                                        }}>
                                                                                                        <i className="uil-check-square"></i>
                                                                                                    </button>
                                                                                                    <Tooltip
                                                                                                        style={{
                                                                                                            marginBottom: 2
                                                                                                        }}
                                                                                                        placement="top" isOpen={this.state["detail_simpeg_" + data.id]} target={"proses_" + data.id}
                                                                                                        toggle={() => {
                                                                                                            this.setState({
                                                                                                                ["detail_simpeg_" + data.id]: !this.state["detail_simpeg_" + data.id]
                                                                                                            })
                                                                                                        }}
                                                                                                    >Kirim Ke SIMPEG</Tooltip>
                                                                                                </span>
                                                                                                // :
                                                                                                // ''
                                                                                            }

                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        })

                                                                        :
                                                                        <tr style={{ border: '1px solid #c8cce1' }}>
                                                                            <td colSpan="5" className="text-center">Tidak Ada Data</td>
                                                                        </tr>
                                                                    :
                                                                    <tr style={{ border: '1px solid #c8cce1' }}>
                                                                        <td colSpan="5" className="text-center"><Spinner className="m-2" color="primary" /></td>
                                                                    </tr>

                                                            }
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </Col>
                                            <ConfirmAlert
                                                confirmTitle="Konfirmasi!"
                                                confirmInfo={this.state.confirmInfo}

                                                loadingTitle="Mengambil data"
                                                loadingInfo="Tunggu beberapa saat"

                                                successTitle="Berhasil!"
                                                successInfo="Data berhasil diproses"

                                                failedTitle="Gagal!"
                                                failedInfo="Data gagal diproses"

                                                showConfirm={this.state.confirm}
                                                showLoading={this.state.loading}
                                                showSuccess={this.state.success}
                                                showFailed={this.state.failed}

                                                response={this.confirmResponse}
                                            />
                                        </Row>


                                        <Row className="mb-1">
                                            <Col md="3"> <Link to="/kepegawaian/integrasi_diklat_simpeg_bkn.html?" className="waves-effect">
                                                <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                            </Link></Col>
                                            {/* <Col md="9"> */}

                                            {/* </Col> */}
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>

        )
    }
}

//export default IndexView
export default withRouter(IndexView);